module.exports = __webpack_public_path__ + "img/PodeAssistirCFC.c1f91f2c.png";